import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useUserRole, AppRole } from "@/hooks/useUserRole";
import { BrandedLoader } from "@/components/BrandedLoader";

interface RoleRouteProps {
  children: ReactNode;
  allow: AppRole[];
}

export function RoleRoute({ children, allow }: RoleRouteProps) {
  const { user, isLoading: authLoading } = useAuth();
  const { roles, isAdmin, isForeman, isWorker, isLoading } = useUserRole();
  const location = useLocation();

  if (authLoading || isLoading) {
    return <BrandedLoader />;
  }
  if (!user) {
    return <Navigate to={`/admin/auth?returnTo=${encodeURIComponent(location.pathname)}`} replace />;
  }
  // Respect impersonation: when admin is viewing-as a crew member,
  // isAdmin is forced false and isForeman/isWorker reflect the impersonated role.
  const effective: AppRole[] = [
    ...(isAdmin ? ["admin" as AppRole] : []),
    ...(isForeman ? ["foreman" as AppRole] : []),
    ...(isWorker ? ["worker" as AppRole] : []),
  ];
  const pool = effective.length ? effective : roles;
  const ok = pool.some((r) => allow.includes(r));
  if (!ok) {
    // Non-admins land on the crew home menu (tiles), not a content page.
    return <Navigate to="/admin/home" replace />;
  }
  return <>{children}</>;
}